import React from 'react';
import Utils from 'utils';
// import { Tooltip } from 'pui-react-tooltip';
// import { OverlayTrigger } from 'pui-react-overlay-trigger';

// -------------------------------------------------------


const progressList = ['assign_complete', 'draft', 'waiting_post', 'insight_check', 'claim', 'complete'];

class Calender extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init();
    this.update = {};
  }

  /*
   * ステートの設定
   */
  init() {
    const initialBatchMessage = (this.props.data.workflow || {}).post_remind_template_text || '';

    this.state = {
      sort: 'register_date',
      sort_order: 'desc',
      is_loading: false,
      updateData: {},
      batch_date: '',
      batch_message: initialBatchMessage,
      is_modal_open: false,
      selected_template_detail: null,
    };
  }

  /**
   * datetime-local形式 (YYYY-MM-DDThh:mm) に変換するヘルパー
   */
  formatDateForInput(dateString) {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '';
      
      // 日本時間に合わせたオフセット計算をして YYYY-MM-DDThh:mm を抽出
      const offset = date.getTimezoneOffset() * 60000;
      const localISOTime = (new Date(date - offset)).toISOString().slice(0, 16);
      return localISOTime;
    } catch (e) {
      return '';
    }
  }

  /*
   * ソート変更
   */
  changeSort(sort) {
    let order = (this.state.sort === sort && this.state.sort_order === 'desc') ? 'asc' : 'desc';
    this.setState({ sort: sort, sort_order: order, is_loading: true });

    setTimeout(function () {
      this.setState({ is_loading: false });
    }.bind(this), 50);
  }

  /*
   * ワークフローオプションの更新 (個別設定の保存)
   */
  updateEvent(insta_user_id, column) {
    const inputElement = this.update[insta_user_id][column];
    if (!inputElement) return;

    let value = inputElement.value;

    if (inputElement.type === 'checkbox') {
      value = inputElement.checked ? 1 : 0;
    } else if (inputElement.type === 'date' || inputElement.type === 'datetime-local') {
      value = value || null;
    }

    let update = {
      project_id: this.props.data.project.id,
      insta_user_id: insta_user_id,
      column: column.replace('option_', ''),
      value: value
    };
    
    Utils.request.bind(this)('/api/project/workflow/update_workflow_status', update,
      function (res) {
        let updateData = { ...this.state.updateData };
        if (updateData[insta_user_id] === undefined) updateData[insta_user_id] = {};
        updateData[insta_user_id][update.column] = update.value;
        this.setState({ updateData: updateData });
        console.log('Status Updated:', update.column, update.value);
      }.bind(this)
    );
  }

  /*
   * 一括メッセージ設定の保存
   */
  saveBatchMessage() {
    if (!confirm('一括メッセージ設定を保存しますか？')) return;

    const params = {
      project_id: this.props.data.project.id,
      message: this.state.batch_message
    };

    Utils.request.bind(this)('/api/project/workflow/update_workflow_post_template', params,
      function (res) {
        alert('一括メッセージを保存しました');
      }.bind(this)
    );
  }

  /*
   * 投稿予定日時の一括反映
   */
  applyBatchSchedule() {
    if (!this.state.batch_date) {
      alert('反映する日付を選択してください');
      return;
    }

    if (!confirm('表示されている全てのインフルエンサーに投稿予定日時を反映しますか？')) return;

    const list = this.getInfluencerList();
    list.forEach((d) => {
      if (this.update[d.insta_user_id] && this.update[d.insta_user_id]['post_schedule']) {
        // 直接DOMの値を書き換えてからupdateEventを発火
        this.update[d.insta_user_id]['post_schedule'].value = this.state.batch_date;
        this.updateEvent(d.insta_user_id, 'post_schedule');
      }
    });
  }

  /*
   * テンプレート操作系
   */
  viewTemplateDetail(template) {
    this.setState({ selected_template_detail: template });
  }

  backToTemplateList() {
    this.setState({ selected_template_detail: null });
  }

  selectTemplate(templateText) {
    if (this.state.batch_message) {
      if (!confirm('入力済みのメッセージがありますが、テンプレートを上書きしますか？')) {
        return;
      }
    }
    this.setState({ 
      batch_message: templateText,
      is_modal_open: false,
      selected_template_detail: null
    });
  }

  /*
   * 表示対象のインフルエンサーリスト取得
   */
  getInfluencerList() {
    let data = this.props.data;
    let influencers = [];
    let list = Utils.createObjectToArray(data.workflow.influencers);

    list.map((d) => {
      // 既存のステータスをセット
      d.post_schedule = d.status.post_schedule;
      d.post_remind_flg = d.status.post_remind_flg;
      d.post_remind_text = d.status.post_remind_text;

      // JSONオプションの展開
      try {
        let json = JSON.parse(d.status.workflow_option);
        for (let i in json) d['option_' + i] = json[i];
      } catch (e) { }

      // 編集中の最新データを上書き（stateに保存されている一時データ）
      if (this.state.updateData[d.insta_user_id]) {
        for (let i in this.state.updateData[d.insta_user_id]) {
          const val = this.state.updateData[d.insta_user_id][i];
          if (i === 'post_schedule' || i === 'post_remind_flg' || i === 'post_remind_text') {
            d[i] = val;
          } else {
            d['option_' + i] = val;
          }
        }
      }

      if (d.status.is_assign === 1 || progressList.indexOf(d.progress) >= 0) {
        influencers.push(d);
      }
    });

    return Utils.sort(influencers.concat(), this.state.sort, this.state.sort_order);
  }

  render() {
    let data = this.props.data;
    let templates = data.workflow.post_remind_template || [];
    let detail = this.state.selected_template_detail;

    let columns = [
      { id: 'full_name', name: 'インフルエンサー名', value: 'direct', fmt: 'full_name' },
      { id: 'insta_id', name: 'InstagramID', value: 'direct', fmt: 'str' },
      { id: 'post_remind_flg', name: 'リマインド設定', value: 'option', fmt: 'checkbox' },
      { id: 'post_schedule', name: '投稿予定日時', value: 'option', fmt: 'date' },
      { id: 'option_draft', name: '下書き', value: 'option', fmt: 'draft' },
      { id: 'post_remind_text', name: '個別メッセージ文章', value: 'str', fmt: 'textarea' },
    ];

    let influencers_result = [];
    if (this.state.is_loading === false) {
      influencers_result = this.getInfluencerList();
    }

    let projectWidth = (200 * columns.length);

    return (
      <div className="project-calender">
        {/* テンプレート選択モーダル (省略せず保持) */}
        {this.state.is_modal_open && (
          <div className="template-modal-overlay" onClick={() => this.setState({ is_modal_open: false, selected_template_detail: null })}>
            <div className="template-modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h3>{detail ? 'テンプレート詳細' : 'メッセージテンプレートを選択'}</h3>
                <i className="material-icons close-btn" onClick={() => this.setState({ is_modal_open: false, selected_template_detail: null })}>close</i>
              </div>
              <div className="modal-body">
                {detail ? (
                  <div className="template-detail-view">
                    <div className="detail-content">{detail.message_text}</div>
                    <div className="detail-actions">
                      <button className="back-btn" onClick={() => this.backToTemplateList()}>戻る</button>
                      <button className="apply-btn" onClick={() => this.selectTemplate(detail.message_text)}>このテンプレートを反映する</button>
                    </div>
                  </div>
                ) : (
                  templates.length > 0 ? (
                    <ul className="template-selection-list">
                      {templates.map((t, idx) => (
                        <li key={idx} onClick={() => this.viewTemplateDetail(t)}>
                          <div className="template-text-preview">{t.message_text}</div>
                          <div className="template-select-action">詳細を見る</div>
                        </li>
                      ))}
                    </ul>
                  ) : <p className="no-template">利用可能なテンプレートがありません。</p>
                )}
              </div>
            </div>
          </div>
        )}

        {/* 一括設定メニュー */}
        <div className="casting-list-menus">
          <div className="batch-update-area">
            <span>投稿予定日時の一括入力: </span>
            <input 
              type="datetime-local" 
              className="batch-date-input"
              value={this.state.batch_date} 
              onChange={(e) => this.setState({ batch_date: e.target.value })} 
            />
            <button className="apply-btn" onClick={this.applyBatchSchedule.bind(this)}>反映</button>
          </div>
        </div>

        <div className="post-list-contents">
          <ul className="projects-list-ul" style={{ width: projectWidth }}>
            <li className="projects-header">
              <div className="score-box">
                {columns.map((d, key) => (
                  <div className={'projects-score ' + d.id} key={key} onClick={this.changeSort.bind(this, d.id)}>
                    <p>{d.name}</p>
                    <div className="sort">
                      {(this.state.sort === d.id && this.state.sort_order === 'asc') ? <i className="material-icons on">keyboard_arrow_up</i> : <i className="material-icons off">keyboard_arrow_up</i>}
                      {(this.state.sort === d.id && this.state.sort_order === 'desc') ? <i className="material-icons on">keyboard_arrow_down</i> : <i className="material-icons off">keyboard_arrow_down</i>}
                    </div>
                  </div>
                ))}
              </div>
            </li>

            {influencers_result.map((d, index) => {
              if (this.update[d.insta_user_id] === undefined) this.update[d.insta_user_id] = {};
              
              return (
                <li key={index}>
                  <div className="score-box score-body">
                    {columns.map((c, key) => {
                      let val = (d[c.id] === undefined) ? '' : d[c.id];

                      // 日付項目のレンダリング
                      if (c.fmt === 'date') {
                        const formattedDate = this.formatDateForInput(val);
                        return (
                          <div className={'projects-score ' + c.id} key={key}>
                            <input 
                              type="datetime-local" 
                              className="input-date"
                              ref={(input) => { this.update[d.insta_user_id][c.id] = input }} 
                              onBlur={this.updateEvent.bind(this, d.insta_user_id, c.id)} 
                              defaultValue={formattedDate} 
                            />
                          </div>
                        );
                      }

                      // チェックボックス項目のレンダリング
                      if (c.fmt === 'checkbox') {
                        return (
                          <div className={'projects-score ' + c.id} key={key}>
                            <label className="checkbox-label">
                              <input 
                                type="checkbox" 
                                ref={(input) => { this.update[d.insta_user_id][c.id] = input }} 
                                onChange={this.updateEvent.bind(this, d.insta_user_id, c.id)} 
                                defaultChecked={parseInt(val) === 1} 
                              />
                              <span>有効</span>
                            </label>
                          </div>
                        );
                      }

                      // 下書き
                      if (c.fmt === 'draft') {
                        const lastDraft = d.drafts && d.drafts[d.drafts.length - 1];
                        return (
                          <div className={'projects-score ' + c.id} key={key}>
                            {lastDraft && (
                              <a href={'/draft/' + lastDraft.unique_id} target="_blank" className="draft-link">最終下書き</a>
                            )}
                          </div>
                        );
                      }

                      // テキストエリア
                      if (c.fmt === 'textarea') {
                        return (
                          <div className={'projects-score ' + c.id} key={key}>
                            <textarea 
                              className="input-textarea"
                              style={{ width: '90%', height: '60px', fontSize: '12px' }}
                              ref={(input) => { this.update[d.insta_user_id][c.id] = input }} 
                              onBlur={this.updateEvent.bind(this, d.insta_user_id, c.id)}
                              defaultValue={val}
                              placeholder="個別メッセージを入力"
                            />
                          </div>
                        );
                      }

                      // 名前
                      if (c.fmt === 'full_name') {
                        return (
                          <div className={'projects-score ' + c.id} key={key}>
                            <img src={d.thumbnail} alt="" style={{ width: '24px', height: '24px', borderRadius: '50%', marginRight: '5px' }} />
                            {val || '-'}
                          </div>
                        );
                      }

                      return (
                        <div className={'projects-score ' + c.id} key={key}>
                          {val || '-'}
                        </div>
                      );
                    })}
                  </div>
                </li>
              );
            })}
          </ul>
        </div>

        {/* 一括メッセージ設定セクション */}
        <div className="batch-message-section" style={{ marginTop: '30px', padding: '20px', borderTop: '1px solid #ccc', backgroundColor: '#f9f9f9' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
            <h3 style={{ fontSize: '14px', fontWeight: 'bold' }}>一括メッセージ設定</h3>
            <div className="batch-message-actions">
              <button className="template-btn" onClick={() => this.setState({ is_modal_open: true })}>テンプレート</button>
              <button className="apply-btn" onClick={this.saveBatchMessage.bind(this)} style={{ marginLeft: '10px', backgroundColor: '#2196F3', color: '#fff', border: 'none', padding: '5px 15px', borderRadius: '4px' }}>保存</button>
            </div>
          </div>
          <textarea 
            style={{ width: '100%', height: '100px', padding: '10px', boxSizing: 'border-box' }}
            value={this.state.batch_message}
            onChange={(e) => this.setState({ batch_message: e.target.value })}
            placeholder="一括送信用のメッセージを入力してください"
          />
        </div>
      </div>
    );
  }
}

export default Calender;